import React from 'react'
import {Icon} from '@chakra-ui/react'

const GridIconB = (props) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <rect x="0.5" y="4.5" width="9" height="15" rx="0.5" stroke="currentColor" />
            <rect
                x="19.5"
                y="8.5"
                width="4"
                height="7"
                rx="0.5"
                fill="currentColor"
                stroke="currentColor"
            />
            <rect
                x="13.5"
                y="8.5"
                width="4"
                height="7"
                rx="0.5"
                fill="currentColor"
                stroke="currentColor"
            />
        </Icon>
    )
}

export default GridIconB
